export enum UserRole {
  ADMIN = 'ADMIN',
  CREW = 'CREW',
}

export enum TicketStatus {
  PENDING = 'PENDING',
  ASSIGNED = 'ASSIGNED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  ON_HOLD = 'ON_HOLD',
  PENDING_ASSIGNMENT = 'PENDING_ASSIGNMENT',
}

export enum TicketPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

export enum CrewStatus {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
}

export enum AssignmentTypes {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC',
  UNASSIGNED = 'UNASSIGNED',
}

export enum CustomFieldTypes {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  SELECT = 'SELECT',
}

export enum CustomFieldEntity {
  TICKET = 'TICKET',
}

export enum GeomType {
  POINT = 'POINT',
  LINESTRING = 'LINESTRING',
  POLYGON = 'POLYGON',
}
